import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    menuPaper: {
      padding: 0,
      width: 422,
      minHeight: 280,
      maxHeight: 556,
    },
    menuList: {},
    buttonsWrapper: {
      padding: theme.spacing(2),
    },
    menuCardsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(1),
    },
    menuCards: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    searchField: {
      width: '100%',
      marginBottom: theme.spacing(0.5),
      height: 40,
      '&$extraMarginBottom': {
        marginBottom: theme.spacing(1.5),
      },
    },
    extraMarginBottom: {},
    buttonHeader: {
      width: '100%',
      marginBottom: theme.spacing(1.5),
    },
  }),
  { name: 'PromptMenu' }
);
